import { defineAsyncComponent } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';

import { useAuthenticationStore } from './store/useAuthenticationStore';
import Home from './view/home/ResultsHome.vue';

export const ROUTE_NAMES = {
  HOME: 'home',
  ADMIN: 'admin',
};

const AdminHome = defineAsyncComponent(() => import('./view/admin/AdminHome.vue'));
const AdminPage = defineAsyncComponent(() => import('./view/admin/AdminPage.vue'));
const CreateCompetition = defineAsyncComponent(
  () => import('./view/admin/competition/CreateCompetition.vue'),
);
const EditCompetition = defineAsyncComponent(
  () => import('./view/admin/competition/EditCompetition.vue'),
);
const CreateClass = defineAsyncComponent(() => import('./view/admin/CreateClass.vue'));
const CreateCompetitor = defineAsyncComponent(
  () => import('./view/admin/competitor/CreateCompetitor.vue'),
);
const EditCompetitor = defineAsyncComponent(
  () => import('./view/admin/competitor/EditCompetitor.vue'),
);
const CreateClub = defineAsyncComponent(() => import('./view/admin/CreateClub.vue'));
const MergeCompetitor = defineAsyncComponent(() => import('./view/admin/MergeCompetitor.vue'));
const OverallScores = defineAsyncComponent(() => import('./view/admin/OverallScores.vue'));

const routes = [
  { path: '/', component: Home, name: ROUTE_NAMES.HOME },
  { path: '/competition/:id', component: Home },
  {
    path: '/admin',
    component: AdminHome,
    meta: { requiresAuth: true },
    children: [
      { path: '', component: AdminPage, name: ROUTE_NAMES.ADMIN },
      { path: 'class/create', component: CreateClass },
      { path: 'club/create', component: CreateClub },
      { path: 'competition/:id', component: AdminPage },
      { path: 'competition/create', component: CreateCompetition },
      { path: 'competition/edit/:id', component: EditCompetition },
      { path: 'competitor/create', component: CreateCompetitor },
      { path: 'competitor/merge', component: MergeCompetitor },
      { path: 'competitor/update/:id', component: EditCompetitor },
      { path: 'overall', component: OverallScores },
    ],
  },
  { path: '/:pathMatch(.*)', redirect: { name: ROUTE_NAMES.HOME } },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const store = useAuthenticationStore();
  const isAuthenticated = await store.checkAuthentication();

  if (to.meta.requiresAuth && !isAuthenticated) {
    return '/';
  }

  return true;
});
